export default __webpack_public_path__ + "static/media/playicon.5b1d37ca.svg";